module.exports = __webpack_public_path__ + "img/intro-circle.2dda76e3.svg";